import React from "react";

import SrrRowBase from "./SrrRowBase";

/**
 * Содержимое таблицы UVIN: Лояльность сводный по дилерам
 * @param row
 * @constructor
 */
const ReportReturnLoyaltyServiceByDealerTable = ({ row }) => {
  const lastItem = {
    sale5: 0,
    serviceCars5: 0,
    Loyalty5: 0,
    sale10: 0,
    serviceCars10: 0,
    Loyalty10: 0,
  };

  const renderItem = [
    row.dealer.DealerName,
    row.dealer.city,
    row.dealer.INN,
    row.dealer.entfCode,
    row.dealer.subject,
    row.dealer.FO,
    row.dealer.status === "active" ? "1" : "0",
    ...row.periods
      .map((el) => {
        lastItem.sale5 += el.sale5;
        lastItem.serviceCars5 += el.serviceCars5;
        lastItem.Loyalty5 += el.Loyalty5;
        lastItem.sale10 += el.sale10;
        lastItem.serviceCars10 += el.serviceCars10;
        lastItem.Loyalty10 += el.Loyalty10;

        return [
          el.sale5,
          el.serviceCars5,
          el.Loyalty5,
          el.sale10,
          el.serviceCars10,
          el.Loyalty10,
        ];
      })
      .flat(),
    lastItem.sale5,
    lastItem.serviceCars5,
    lastItem.Loyalty5,
    lastItem.sale10,
    lastItem.serviceCars10,
    lastItem.Loyalty10,
  ];

  return <SrrRowBase cells={renderItem} />;
};

export default ReportReturnLoyaltyServiceByDealerTable;
